import { Component } from "react"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"


/* Widget Layout */
class Layout extends Component {

    /* Draw button */
    _button = () => {

        /* Fields */
        const { reload } = this.props

        /* Check Reload */
        if (reload) {
            return <div onClick={() => reload()} className="button">{t("layout.retry")}</div>
        }
    }

    render = () => {

        /* Fields */
        const { status, type } = this.props

        /* Empty */
        if (status === "empty") {

            /* Messages */
            if (type === "messages") {
                return (
                    <div className="table--layout-box">
                        <img src="/images/support-chat.png" alt="Support Chat" style={{ opacity: 0.6 }} />
                        <h2>{t("support.noMessages")}</h2>
                        <p>{t("support.noMessagesDesc")}</p>
                    </div>
                )
            }
        }

        /* Error */
        if (status === "error") {
            return (
                <div className="table--layout-box">
                    <img src="/images/alert.png" alt="Alert" />
                    <h2>{t("layout.serverError")}</h2>
                    <p>{t("layout.serverErrorDesc")}</p>
                    {this._button()}
                </div>
            )
        }

        /* Network */
        if (status === "network") {
            return (
                <div className="table--layout-box">
                    <img src="/images/wifi.png" alt="Wifi" />
                    <h2>{t("layout.networkError")}</h2>
                    <p>{t("layout.networkErrorDesc")}</p>
                    {this._button()}
                </div>
            )
        }

        /* Permission */
        if (status === "permission") {
            return (
                <div className="table--layout-box">
                    <img src="/images/user-key.png" alt="User Key" />
                    <h2>{t("layout.noAccess")}</h2>
                    <p>{t("layout.noAccessDesc")}</p>
                    {this._button()}
                </div>
            )
        }

        /* Key */
        if (status === "key") {
            return (
                <div className="table--layout-box">
                    <img src="/images/key.png" alt="Key" />
                    <h2>{t("layout.invalidKey")}</h2>
                    <p>{t("layout.invalidKeyDesc")}</p>
                    <div onClick={() => window.location.reload()} className="button">{t("layout.reload")}</div>
                </div>
            )
        }

        return (
            <div className="table--layout-box">
                <LoadingOutlined />
            </div>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps)(Layout)
